import { Component, OnInit, OnDestroy } from '@angular/core';
import { SingletonEntityDetailsComponent } from '../util/singleton-entity-details.base';
import { Subscription } from '../models/subscription';
import { SubscriptionService } from './subscription.service';
import { EventsServiceManager, EventsService } from '../util/events.service';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';
import { UnauthorizedError } from '../util/http.service';
import { ActionConfirmer } from '../util/confirmation';
import { ActionConfirmationService } from '../util/confirmation/confirmation.service';

@Component({
  selector: 'app-subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.scss'],
})
export class SubscriptionDetailsComponent
  extends SingletonEntityDetailsComponent<Subscription>
  implements OnInit, OnDestroy
{
  private errorsService: EventsService<Error>;

  private actionConfirmer: ActionConfirmer;

  constructor(
    eventsServiceManager: EventsServiceManager,
    private subscriptionService: SubscriptionService,
    dialog: MatDialog
  ) {
    super(eventsServiceManager);
    this.errorsService = eventsServiceManager.get(
      'content.errors',
      new Error()
    );
    this.actionConfirmer = new ActionConfirmationService(dialog);
  }

  confirmCancelPlan() {
    this.subscription.add(
      this.actionConfirmer.confirmAction(
        'Are you sure you want to cancel your plan? You will not be able to access any of your data.',
        () => {
          this.subscription.add(
            this.subscriptionService
              .cancel()
              .pipe(
                catchError((error: Error) => {
                  if (error instanceof UnauthorizedError) {
                    this.errorsService.pushEvent(
                      new Error(
                        'You are not authorized to cancel the current plan.'
                      )
                    );
                  }
                  return of(false);
                })
              )
              .subscribe((isDeleted) => {
                if (isDeleted) {
                  this.eventsService.pushEvent({
                    message: 'Subscription has been cancelled',
                    status: 'success',
                  });
                  // do a full page load at the root after 3s
                  setTimeout(() => {
                    location.href = '/';
                  }, 3000);
                }
              })
          );
        }
      )
    );
  }

  updatePaymentInfo() {
    this.subscriptionService
      .update(location.href, location.href)
      .subscribe(() => {
        location.href = '/checkout.html';
      });
  }

  loadEntity(): Observable<Subscription> {
    return this.subscriptionService.getEntity();
  }
}
